import { Controller } from '@hotwired/stimulus'
import { closeDialog, formDialog } from '../../lib/dialogs.js'

// The rating is a bottom-up sheet: the home pops one by itself for a visit still unrated, the
// history pops one for the visit whose button was tapped. Either way the markup ships inside a
// <template> so the form is built server-side, with its own CSRF token, and only reaches the
// DOM when the sheet opens.
export default class extends Controller {
  static targets = ['template']
  static values = { auto: Boolean }

  connect() {
    if (this.autoValue) this.open()
  }

  open() {
    this.opened = true
    formDialog(this.templateTarget.innerHTML)
  }

  // The sheet lives outside this element, so leaving the screen has to take it down. The
  // history holds one controller per card and the sheet is a singleton, so only whoever
  // opened it may close it.
  disconnect() {
    if (this.opened) closeDialog()
  }
}
